import _ from 'lodash';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import {
  // Input,
  Icon,
  Segment,
  Table,
  Pagination,
  Grid,
  Checkbox,
} from 'semantic-ui-react';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../../app/stores/store';
import ReportsModal from '../TableReports/ReportsModal';
import { Link } from 'react-router-dom';
// import reactStringReplace from "react-string-replace";
import '../../app/common/MediaQuery/responsive-table-style.css';
import DynamicTableCSVReport from './DynamicTableCSVReport';
import reactStringReplace from 'react-string-replace';
import LoadingComponent from '../../app/layout/LoadingComponent';

interface Props {
  data: any;
  name: any;
  actiontype: string;
  currentPage: any;
  setCurrentPage: Dispatch<SetStateAction<any>>;
  // ArrayId:[];
}
/* Sort - End*/
function DynamicTableModalComponent({
  data,
  name,
  currentPage,
  setCurrentPage,
}: Props) {
  const {
    dashboardStore,
    reportStore,
    userStore: { user },
  } = useStore();
  const { ArrayData, LinkExsitingArray } = reportStore;

  const tableName = name;
  // localStorage.setItem(
  // tableName,
  // "isGoing,isHost"
  // );

  // eslint-disable-next-line
  let tableHeads: any;
  if (
    localStorage.getItem(tableName) !== undefined &&
    localStorage.getItem(tableName) !== null
  ) {
    // eslint-disable-next-line
    tableHeads = localStorage.getItem(tableName)!.split(',');
  } else {
    localStorage.setItem(tableName, '');
  }
  // const tableHeads = tableHead;
  //data.map((i:any) => str.map((j) => delete i[j]));
  /* Sort - Start*/
  function exampleReducer(state: any, action: any) {
    switch (action.type) {
      case 'CHANGE_SORT':
        if (state.column === action.column) {
          return {
            ...state,
            tabledata: state.tabledata.slice().reverse(),
            direction:
              state.direction === 'ascending' ? 'descending' : 'ascending',
          };
        }
        return {
          column: action.column,
          tabledata: _.sortBy(state.tabledata, [action.column]),
          direction: 'ascending',
        };
      case 'UPDATE_DATA':
        return {
          column: action.column,
          tabledata: data,
          direction: null,
        };
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = React.useReducer(exampleReducer, {
    column: null,
    tabledata: data,
    direction: null,
  });
  const { column, tabledata, direction } = state;

  useEffect(() => {
    // dipatch is called after data is updated via props
    dispatch({ type: 'UPDATE_DATA' });
  }, [data]);
  /*Code for Button - Start*/
  /*Code for Button - Start*/
  /*Code for Pagination - Start*/
  const [postsPerPage] = useState<any>(tableName === 'ReportsTable' ? 10 : 5);
  const [activeRowId, setActiveRowId] = useState<any>(
    dashboardStore.dashboard.rowIdForDynamicTable,
  );
  const [, setHoverRowId] = useState<any>(-1);
  /* Code for Pagination - End*/
  /* Search - Start */
  const [filterObj] = useState<any>([]);
  // const searchFunc = (event: any, data: any) => {

  //   /*Code for Pagination - Start*/
  //   setCurrentPage(1);
  //   /* Code for Pagination - End*/
  //   if (data.value.toString() !== "") {
  //     setFilterObj([
  //       ...filterObj.filter(
  //         (o: any) => o.key.toString() !== data.name.toString()
  //       ),
  //       {
  //         key: data.name.toString(),
  //         filterValue: data.value.toString(),
  //       },
  //     ]);
  //   } else {
  //     setFilterObj(
  //       filterObj.filter((o: any) => o.key.toString() !== data.name.toString())
  //     );
  //   }
  // };
  function filterFunc(obj: any) {
    const result = filterObj.map((fc: any) =>
      obj[fc.key]
        ? obj[fc.key].toString().includes(fc.filterValue.toString())
        : null,
    );
    if (result.filter((e: any) => e === false).length === 0) return true;
    return false;
  }
  /* Search - End */
  const handleChange = () => {
    if (tableName === 'ReportsTable') {
      dashboardStore.setTableClicked(
        tabledata.length > 0
          ? [
              'title',
              'type',
              'element',
              'asset_tracking_status',
              'physical_sensor_qrcode',
              'physical_sensor_barcode',
              'originindia',
              'year',
              'language',
            ]
          : null,
        tableName,
      );
      dashboardStore.reportsConfigurationOpen(true);
    } else {
      let maxLength = 0;
      let maxObjectIndex = 0;
      for (let i = 0; i <= tabledata.length - 1; i++) {
        if (Object.keys(tabledata[i]).length > maxLength) {
          maxLength = Object.keys(tabledata[i]).length;
          maxObjectIndex = i;
        }
      }
      let setting = Object?.keys(tabledata[maxObjectIndex]);
      setting = setting.filter((s) => s !== 'name');

      dashboardStore.setTableClicked(
        tabledata.length > 0 ? setting : null,
        tableName,
      );
      dashboardStore.reportsConfigurationOpen(true);
    }
  };
  /////////////// Edit Function (Receving Delivery )

  //////// function to get clicked value
  const getClickedValue = (rowData: any, tableName: string) => {
    if (tableName === 'ReceivingTable') {
      dashboardStore.showClickedValueForReceiving(
        rowData.id,
        rowData.receivingTitle,
        rowData.barcode_Package,
      );
    } else if (tableName === 'OrderRegisterTable') {
      dashboardStore.dashboard.deliveryOrderTableClicked = true;
      dashboardStore.setOrderRequestDetails(rowData);
    } else if (tableName === 'AssetTable') {
      dashboardStore.showClickedValueForAssetTable(rowData.id);
    } else if (
      tableName === 'DeliveryTableSmall' ||
      tableName === 'DeliveryTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (
      tableName === 'OutwardsTableSmall' ||
      tableName === 'OutwardsTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (
      tableName === 'InwardsTableSmall' ||
      tableName === 'InwardsTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (tableName === 'AssetTableTag') {
      dashboardStore.showClickedValueForAssetTable(rowData.id);
    }
    setActiveRowId(rowData.itemId);
  };

  //   const newArr:any[]=[]
  //   const ArrayData  = (rowData: any)=>{

  //       // Array.push()
  //     //   for (let i = 0; i < newArr.length; i++) {
  //     //  if(newArr.indexOf(rowData) === -1) {
  //     //       newArr.push(rowData);
  //     //   }

  //     //   }
  // //     newArr.push({
  // //       itemGroupName: rowData.itemGroupName,
  // // itemId: rowData.itemId,
  // // name: rowData.name,
  // //     })
  //     newArr.push(rowData);

  //   }

  return (
    <>
      <Segment className="LinkExisting-style LinkExisting-style-header">
        <Segment className="LinkExisting-style">
          {dashboardStore.dashboard.reportsConfiguration === true ? (
            <ReportsModal
              toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
            />
          ) : null}

          <Table
            sortable
            selectable
            celled
            singleLine
            className="Linkexisting-dynmictable-header"
          >
            <Table.Header></Table.Header>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell></Table.HeaderCell>

                <Table.HeaderCell
                  sorted={column === 'title' ? direction : null}
                  onClick={() =>
                    dispatch({
                      type: 'CHANGE_SORT',
                      column: 'title',
                    })
                  }
                >
                  Title
                </Table.HeaderCell>
                {tableHeads.length > 0
                  ? // You have an array
                    tableHeads.map((i: any, index: number) =>
                      i !== 'id' ? (
                        i.toLowerCase() !== 'title' ? (
                          <Table.HeaderCell
                            key={index + 'tableHead'}
                            sorted={column === '{i}' ? direction : null}
                            onClick={() =>
                              dispatch({
                                type: 'CHANGE_SORT',
                                column: '{i}',
                              })
                            }
                          >
                            {reactStringReplace(
                              (
                                i.charAt(0).toUpperCase() +
                                i.slice(1).split('_').join(' ')
                              )
                                .split(' ')
                                .map(
                                  (i: any) =>
                                    i.charAt(0).toUpperCase() +
                                    i.slice(1) +
                                    ' ',
                                ),
                              /([A-Z])/,
                              (m: any) => ' ' + m,
                            )}
                          </Table.HeaderCell>
                        ) : null
                      ) : null,
                    )
                  : {}}
              </Table.Row>
            </Table.Header>
            <Table.Body className="tabletexttruncate">
              {tabledata

                .filter(filterFunc)
                .slice(
                  parseInt(currentPage, 10) * parseInt(postsPerPage, 10) -
                    parseInt(postsPerPage, 10),
                  parseInt(currentPage, 10) * parseInt(postsPerPage, 10),
                ).length !== 0 ? (
                tabledata
                  // .filter((rowData:any)=>{
                  //     return rowData["itemId"] !== reportStore.LinkExsitingArray;
                  // })
                  .filter(filterFunc)
                  .slice(
                    parseInt(currentPage, 10) * parseInt(postsPerPage, 10) -
                      parseInt(postsPerPage, 10),
                    parseInt(currentPage, 10) * parseInt(postsPerPage, 10),
                  )
                  .map((rowData: any) => (
                    <Table.Row
                      key={rowData['itemId']}
                      active={rowData['itemId'] === activeRowId}
                      onClick={() => getClickedValue(rowData, tableName)}
                      onMouseOver={() => setHoverRowId(rowData['itemId'])}
                    >
                      <Table.Cell>
                        <Checkbox
                          onChange={() => {
                            ArrayData(rowData.itemId);
                            reportStore.HistoryLinksection = rowData['name'];
                          }}
                          defaultChecked={
                            // (clonedStore.existingData.includes(rowData.itemId)?true:false)
                            // ||
                            LinkExsitingArray?.includes(rowData.itemId)
                              ? true
                              : false
                          }
                          // defaultChecked={((clonedStore.existingData.includes(rowData.itemId))  || (LinkExsitingArray?.includes(rowData.itemId)) && (LinkExsitingArray.indexOf(rowData.itemId)) && (clonedStore.existingData.indexOf(rowData.itemId)) ) ? true : false}
                          // defaultChecked={
                          //   clonedStore.existingData.includes(rowData.itemId)
                          //     ? true
                          //     : false
                          // }
                        />
                      </Table.Cell>

                      {tableName === 'LinkExising' ||
                      Object.keys(tabledata[0]).includes('name') ? (
                        <Table.Cell key={rowData['id']}>
                          {
                            <Link to={`/mediaAssets/${rowData['itemId']}`}>
                              {rowData['name']}
                            </Link>
                          }
                        </Table.Cell>
                      ) : null}
                      {/* {
                        tableName === "LinkExising" &&(
                          tableHeads.map((i: any) =>         
                          i !== "name" ? (
                              <Table.Cell key={i}>
                                {rowData[i]}
                                </Table.Cell>
                            ) : null
                        ) 
                          )
                        } */}
                      {/* {tableHeads.map((i: any) =>
                           !Object.keys(tabledata[0]).includes("name") ? (
                              <Table.Cell key={i}>
                                {rowData[i]}</Table.Cell>
                            ) : null
                        )} */}
                      {tableHeads.map((i: any) =>
                        i !== 'name' &&
                        i !== 'title' &&
                        i.toLowerCase() !== 'parent' ? (
                          <>
                            {user?.customerName === 'LVP CMS - AM' ? (
                              <>
                                {i.toLowerCase() ===
                                  'physical_location_vault' ||
                                i.toLowerCase() === 'asset_In_Vault' ? (
                                  <></>
                                ) : i.toLowerCase() ===
                                  'physical_location_room' ? (
                                  <Table.Cell key={i}>
                                    {rowData[`physical_location_vault`]}
                                  </Table.Cell>
                                ) : i.toLowerCase() === 'asset_in_room' ? (
                                  <Table.Cell key={i}>
                                    {rowData[`asset_In_Vault`]}
                                  </Table.Cell>
                                ) : (
                                  <Table.Cell key={i}>{rowData[i]}</Table.Cell>
                                )}
                              </>
                            ) : (
                              <Table.Cell key={i}>{rowData[i]}</Table.Cell>
                            )}
                          </>
                        ) : i.toLowerCase() === 'parent' ? (
                          <Table.Cell key={i}>
                            <Link
                              to={`/mediaAssets/${rowData['parent']?.split(
                                '/',
                              )[0]}`}
                            >
                              {rowData['parent']?.split('/')[1]}
                            </Link>
                          </Table.Cell>
                        ) : null,
                      )}
                    </Table.Row>
                  ))
              ) : (
                <Table.Row
                  style={{
                    height: '21vh',
                    overflow: 'hidden',
                  }}
                >
                  <Table.Cell
                    colSpan={data.length > 0 ? Object.keys(data[0]).length : 9}
                    collapsing
                  >
                    <p className="tableEmptyData">Sorry, no data to show</p>
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </Segment>
        <Segment raised attached="top">
          <Grid columns="3">
            <Grid.Column width={13}></Grid.Column>
            <Segment raised attached="top">
              <div className="dynamicTableFooter">
                {dashboardStore.dashboard.loadingCount ? (
                  <LoadingComponent />
                ) : (
                  <Pagination
                    activePage={currentPage}
                    // defaultActivePage={currentPage}
                    totalPages={Math.ceil(
                      Object.keys(tabledata.filter(filterFunc)).length /
                        postsPerPage,
                    )}
                    onPageChange={(event, data) =>
                      setCurrentPage(data.activePage)
                    }
                  />
                )}
                <div>
                  <DynamicTableCSVReport
                    tableData={tabledata}
                    tableName={tableName}
                  />
                  <div>
                    {tableName !== 'WorkLevelTable' ? (
                      <Icon
                        // onClick={() => dashboardStore.reportsConfigurationOpen(true)}
                        onClick={handleChange}
                        corner="bottom right"
                        size="large"
                        circular
                        inverted
                        color="teal"
                        name="settings"
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </Segment>
          </Grid>
        </Segment>
      </Segment>
    </>
  );
}
export default observer(DynamicTableModalComponent);
